/** @format */
import { Button, Col, Row, Grid } from "antd";
import { url } from "inspector";
import Link from "next/link";
import Image from "next/image";

interface Sec2 {
  locationtypeData: any;
}
export default function Sec2({ locationtypeData }: Sec2) {
  const { useBreakpoint } = Grid;
  const screenSize = useBreakpoint();

  return (
    <Row justify='center' style={{}}>
      <Col lg={24} style={{}}>
        <Row
          justify={"center"}
          style={{ paddingTop: 50, paddingBottom: 50 }}
          gutter={[30, 30]}>
          <Col
            span={24}
            style={{
              textAlign: "center",
              color: "#000000",
              fontWeight: 400,
              fontSize: screenSize.md ? 48 : 28,
            }}>
            <p
              style={{
                marginBottom: 0,
                fontWeight: 500,
                fontFamily: "adobe-garamond-pro",
                fontSize: screenSize.md ? 48 : 28,
              }}>
              We make it easy!
            </p>
          </Col>
          <Col span={24} style={{ textAlign: "center" }}>
            <Image
              src='/newClient.png'
              alt='intro image'
              className='stext5'
              width={
                screenSize.sm
                  ? screenSize.lg
                    ? screenSize.xl
                      ? 1400
                      : 1000
                    : 768
                  : 325
              }
              height={
                screenSize.sm
                  ? screenSize.lg
                    ? screenSize.xl
                      ? 440
                      : 340
                    : 300
                  : 150
              }
            />
          </Col>
          <Col>
            <Link href='/new-clients/0'>
              <Button size='large' type='primary'>
                Schedule a Free Consultation
              </Button>
            </Link>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
